import { useDispatch, useSelector } from "react-redux";
import { basicModalShowHide } from "../../features/modalSlice.js";
import { deleteQuestPack, setDeleteQuestPackId } from "../../features/questPackSlice.js";
import { errorToastify } from "../../utils/toastify.util.js";

const QuestPackDelete = () => {
  const dispatch = useDispatch();
  const { deleteQuestPackId } = useSelector((state) => state.questPack);

  const handleDelete = () => {
    try {
      dispatch(deleteQuestPack({ id: deleteQuestPackId }));
      dispatch(basicModalShowHide());
    } catch (err) {
      errorToastify(err.message);
    }
  };

  const handleCancel = () => {
    dispatch(setDeleteQuestPackId(null));
    dispatch(basicModalShowHide());
  };

  return (
    <>
      <div>
        <h5>Are you sure you want to delete this quest pack?</h5>
      </div>
      <div className="float-end">
        <button type="button" className="btn btn-secondary me-2" onClick={handleCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={handleDelete}>
          Delete
        </button>
      </div>
    </>
  );
};

export default QuestPackDelete;
